import * as actions from "./actionTypes";

export const registrationForm = (
  state = {
    data: {},
    isLoading: false,
    errors: {},
  },
  action,
) => {
  switch (action.type) {
    case actions.SUBMIT_REGISTRATION_FORM_START:
      return {
        ...state,
        isLoading: true,
        errors: {},
      };
    case actions.SUBMIT_REGISTRATION_FORM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        errors: {},
      };
    case actions.SUBMIT_REGISTRATION_FORM_FAILURE:
      return {
        ...state,
        data: {},
        isLoading: false,
        errors: action.errors,
      };

    default:
      return state;
  }
};
